import { React } from 'react';
import { redirect } from 'react-router-dom';
import CreateAccount from '../components/CreateAccount.jsx';
import { getAuthToken } from '../util/auth.jsx'
import backend from '../util/backend.jsx';
import { isEmail, isEqualsToOtherValue } from '../util/validation.jsx'

function CreateAccountPage() {
  return <CreateAccount />;
}

export default CreateAccountPage;

export async function action({ request }) {
  const data = await request.formData();

  const email = data.get('email');
  const password = data.get('password');
  const password2 =  data.get('verify-password');

  const errors = [];

  const validEmail = isEmail(email);
  if (!validEmail) {
    errors.push("Invalid email address");
  }

  const passwordsMatch = isEqualsToOtherValue(password, password2);
  if (!passwordsMatch) {
    errors.push("Passwords do not match");
  }

  if (errors.length > 0) {
    return {errors: errors};
  }

  const acctData = {
    vendor: data.get('vendor'),
    email: email,
    password: password,
  };

  const token = getAuthToken();

  const response = await fetch(`https://${backend}/createAccount`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(acctData)
  });
  const result = await response.json();

  if (response.status === 422 || response.status === 401) {
    return {errors: [result.message]};
  }

  if (!response.ok) {
    return {errors: ['Could not authenticate.']};
  }

  return redirect('/');
}
